const flex = (direction = 'row', justify = 'center', align = 'center') => {
  return `
  display: flex;
  justify-content: ${justify};
  align-items: ${align};
  flex-direction: ${direction};
  `;
};

const posCenterX = (type = 'absolute') => {
  return `
  position: ${type};
  left:50%;
  transform:translateX(-50%);
  `;
};

const posCenterY = (type = 'absolute') => {
  return `
  position: ${type};
  top: 50%;
  transform: translateY(-50%);
  `;
};

const posCenterXY = (type = 'absolute') => {
  return `
  position: ${type};
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  `;
};

// Rem
const pixelToRem = size => `${size / 16}em`;
const MobilePixelToRem = size => `${size / 13}em`;

// Colors
const colors = {
  black: '#0E0E0E',
  transparentBlack: 'rgba(255, 255, 255, 0.8);',
  pureBlack: '#000000',
  white: '#F0F0F0',
  pureWhite: '#FFFFFF',
  green: '#28DE2C',
  grey1: '#3E3E3E',
  grey2: '#6E6E6E',
  grey3: '#9F9F9F',
  grey4: '#CFCFCF',
  grey5: '#E6E6E6',
};

// multilines
const multiLines = (lines = 3) => {
  return `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  `;
};

// font-size vw
const pixelToVw = size => `min(${(100 * size) / 1920}vw,${size}px)`;
const pixelToMobileVw = size => `min(${(100 * size) / 750}vw,${size}px)`;

// theme
const theme = {
  flex,
  posCenterX,
  posCenterY,
  posCenterXY,
  pixelToRem,
  MobilePixelToRem,
  multiLines,
  colors,
  pixelToVw,
  pixelToMobileVw,
};

export default theme;
